import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { certificatesAPI } from '../../services/api';
import useAuthStore from '../../context/authStore';
import toast from 'react-hot-toast';

import BackButton from '../../components/common/BackButton';
export default function CertificateDetailPage() {
  const { id } = useParams();
  const { token } = useAuthStore();

  const { data, isLoading, error } = useQuery({
    queryKey: ['certificate', id],
    queryFn: () => certificatesAPI.getById(id).then((r) => r.data),
    enabled: !!token && !!id,
  });

  if (isLoading) return <div className="p-6">Loading certificate...</div>;
  if (error) return <div className="p-6 text-red-600">Failed to load certificate</div>;

  const cert = data?.certificate;
  if (!cert) return <div className="p-6">Certificate not found</div>;

  const handleDownload = async (revision) => {
    try {
      const res = await certificatesAPI.download(id, revision);
      let url = res.data.downloadUrl;
      if (url && url.startsWith('/')) {
        url = `${window.location.protocol}//${window.location.hostname}${
          window.location.port ? ':' + window.location.port : ''
        }${url}`;
      }
      window.open(url, '_blank');
    } catch (err) {
      const message =
        err?.response?.data?.error ||
        err?.message ||
        'Failed to get download link';
      // 503 from backend means PDF generation not configured
      if (err?.response?.status === 503) {
        toast.error(message, { duration: 8000 });
      } else {
        toast.error(message);
      }
      console.error('certificate download error', err);
    }
  };

  return (
    <div className="p-0 sm:p-2 max-w-4xl mx-auto">
      <BackButton fallbackTo="/certificates" className="mb-4" />
      <h1 className="text-2xl font-semibold mb-2">Certificate: {cert.certificateNumber}</h1>
      <p className="text-gray-600">Course: <strong>{cert.courseTitle}</strong></p>
      <p className="text-gray-600">Recipient: <strong>{cert.recipientName}</strong></p>
      <p className="text-gray-600">Issued: <strong>{new Date(cert.issuedAt || cert.issuedAt || Date.now()).toLocaleString()}</strong></p>
      {cert.downloadCount != null && (
        <p className="text-gray-600">
          Downloads: <strong>{cert.downloadCount}</strong>
          {cert.lastDownloadedAt && (
            <span> (last {new Date(cert.lastDownloadedAt).toLocaleString()})</span>
          )}
        </p>
      )}
      <div className="mt-4">
        <button
          onClick={() => handleDownload()}
          className="btn-primary mr-2"
          disabled={!cert.pdfUrl}
        >
          Download Current PDF
        </button>
        {!cert.pdfUrl && (
          <p className="text-xs text-gray-500 mt-2">PDF not yet generated</p>
        )}
      </div>

      <div className="mt-8 bg-white border rounded-lg p-4">
        <h3 className="font-semibold mb-3">Revision History</h3>
        {(cert.pdfRevisions && cert.pdfRevisions.length > 0) ? (
          <ul className="space-y-3">
            {cert.pdfRevisions.map((r, idx) => (
              <li key={idx} className="flex items-center justify-between">
                <div>
                  <div className="text-sm text-gray-800">Revision {idx + 1}</div>
                  <div className="text-xs text-gray-500">Uploaded: {new Date(r.uploadedAt).toLocaleString()}</div>
                </div>
                <div>
                  <button onClick={() => handleDownload(idx)} className="px-3 py-1 border rounded">Download</button>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <div className="text-gray-500">No previous revisions available</div>
        )}
      </div>
    </div>
  );
}
